/* eslint-disable no-lone-blocks */
/* eslint-disable react/prop-types */
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { Button, Spinner } from 'reactstrap';
import { Col, FlexboxGrid, Form, FormGroup } from 'rsuite';
import FlexboxGridItem from 'rsuite/lib/FlexboxGrid/FlexboxGridItem';
import SelectInput from '~/components/selectInput/SelectInput';
import api from '~/services/api';
import { addCompanyId, addUserID } from '~/store/modules/Grupos/actions';
import '../../../Page.css';

function SearchUser({ setIsSelected, loading, setLoading, form, setForm }) {
  const [userData, setUserData] = useState([{}]);
  const [companyData, setCompanyData] = useState([{}]);
  const dispatch = useDispatch();

  useEffect(() => {
    async function getData() {
      const params = {
        skip: 0,
        take: 1000,
      };
      await api
        .get(`/Pessoa/GetPessoaPaginado?${qs.stringify(params)}`)
        .then((response) => {
          const { data } = response.data;
          setLoading(false);
          setCompanyData(data);
        });
    }
    getData();
  }, []);

  useEffect(() => {
    async function getData() {
      const params = {
        skip: 0,
        take: 1000,
        idEmpresa: form.idPessoaEmpresa,
      };
      await api
        .get(`/Usuario/GetUsuarioByEmpresa?${qs.stringify(params)}`)
        .then((response) => {
          const { data } = response.data;
          setLoading(false);
          setUserData(data);
        });
    }
    getData();
  }, [form.idPessoaEmpresa]);

  function handleFormChange(value) {
    setForm({ ...form, ...value });
  }

  return (
    <Form
      style={{ width: '100%' }}
      formValue={form}
      onChange={handleFormChange}
      onSubmit={() => {
        setIsSelected(true);
        dispatch(addUserID(form.id));
        dispatch(addCompanyId(form.idPessoaEmpresa));
      }}
      fluid
      className="pageForm"
    >
      <FormGroup className="pageFormContainer" style={{ display: 'block' }}>
        <FlexboxGrid className="marginTop" style={{ marginTop: '16px' }}>
          <FlexboxGridItem componentClass={Col} colspan={24} md={12}>
            <SelectInput
              margin="0"
              width="100%"
              label="Selecione a empresa"
              form={form}
              valueKey="idPessoaEmpresa"
              labelKey="razaoSocialNome"
              setForm={setForm}
              value={form.idPessoaEmpresa}
              options={companyData}
              placeholder="Escolha uma opção"
              state="idPessoaEmpresa"
              onChange={() => {
                setIsSelected(false);
              }}
            />
          </FlexboxGridItem>
          <FlexboxGridItem componentClass={Col} colspan={24} md={12}>
            <SelectInput
              margin="0"
              width="100%"
              label="Selecione o usuário"
              form={form}
              valueKey="id"
              labelKey="login"
              setForm={setForm}
              value={form.id}
              options={userData}
              placeholder="Escolha uma opção"
              state="id"
              disabled={!form.idPessoaEmpresa}
              onChange={() => {
                setIsSelected(false);
              }}
            />
          </FlexboxGridItem>
        </FlexboxGrid>
      </FormGroup>
      <Button color="primary" disabled={!form.id} size="sm" type="submit">
        {loading ? (
          <Spinner size="sm" color="light" />
        ) : (
          <>
            <FaSearch /> Buscar
          </>
        )}
      </Button>
    </Form>
  );
}

export default SearchUser;
